import {IComponentController, IComponentOptions} from "angular";
import {getDefaultAvatarUrl, UserDto} from "../../model/User";

import './UserCard.scss';
import {CroppieDialog} from "../../../image_cropper/dialogs/CroppieDialog";
import {UserEventType, UserService} from "../../../users_service/service/user.service";
import {CroppieOptionsServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {CroppieOptionsService} from "../../../image_cropper/service/CroppieOptionsService";
import {ImageResponse} from "../../../image_cropper/model/ImageModel";


export class UserCard implements IComponentController {

    public static instance: IComponentOptions = {
        template: require("./UserCard.html"),
        controller: [UserServiceName, '$mdDialog', CroppieOptionsServiceName, UserCard],
        bindings: {
            'user': '<'
        }
    };

    private user: UserDto;

    constructor(private userService: UserService,
                private $mdDialog: angular.material.IDialogService,
                private croppieOptionsService: CroppieOptionsService) {
    }

    $onInit(): void {
        let user = this.user;
        if (user.avatarUrl) {
            user.hasAvatar = true;
        } else {
            user.hasAvatar = false;
            user.avatarUrl = getDefaultAvatarUrl(user.gender);
        }
    }


    openCropDialog = (user: UserDto, $event: MouseEvent) => {
        this.croppieOptionsService.submitNewOptions({
            viewport: {
                width: 400,
                height: 400
            },
            boundary: {
                width: 410,
                height: 410
            }
        });
        this.$mdDialog.show(CroppieDialog.instance($event))
            .then((resp: ImageResponse) => {
                let avatarId = resp.id;
                this.user.avatarUrl = resp.imageUrl;
                this.userService.updateUserAvatar(avatarId, this.user.id)
                    .then(resp => {
                        user.avatarId = avatarId;
                        this.userService.userChanged(UserEventType.UPDATED, user);
                    });
            });
    };

}